import { ActionHandler } from "..";
import { getURLParams } from "src/utils/urlParams";
import { getInAppAutoCookie } from "src/utils/authCookieParser";
import { getUpsellAdDataQuery } from "src/api/healthReportUpsell";
import { HealthReportUpsellContent, UpsellAdLocation } from "gql/graphql";
import { setUpsellAdData } from "src/utils/redux/slices/upsellAdData";

let pendingUpsellAdDataPromise: ReturnType<typeof getUpsellAdDataQuery> | null =
  null;

export const loadUpsellAdData: ActionHandler = ({ store }) => {
  const { ad_location: adLocation } = getURLParams();
  const accessCode = getInAppAutoCookie()?.accessCode;
  if (!accessCode || !adLocation || pendingUpsellAdDataPromise) return;

  pendingUpsellAdDataPromise = getUpsellAdDataQuery(
    accessCode,
    adLocation as UpsellAdLocation
  )
    .then((response) => {
      const data = response.data.upsellAdDataList.upsellAdData;

      if (data?.length)
        store.dispatch(
          setUpsellAdData({
            healthReportUpsellContent: data[0]
              .content as HealthReportUpsellContent,
          })
        );

      return response;
    })
    .finally(() => {
      pendingUpsellAdDataPromise = null;
    });
};

export const waitForUpsellAdData: ActionHandler = async () => {
  if (pendingUpsellAdDataPromise) await pendingUpsellAdDataPromise;
};
